//用于修饰promise的错误捕获，使其返回一个数组[err, null]或者[null, data]
export const decorate_ = (promise) => {
  return promise
    .then((data) => [null, data])
    .catch(err => [err, null]);
}